import { type ReactElement } from 'react';
import { ReportsListProps } from '../types';
import ReportListItem from '@/components/reports/ReportListItem';
import { motion } from 'framer-motion';
import { containerVariants } from '../animations';
import { listTableStyles } from '@/components/system/listTableStyles';

type Props = Omit<ReportsListProps, 'isLoading' | 'viewMode'>;

function DashboardAsTable({ reports, onDelete, onExport }: Props): ReactElement {
    const DASHBOARD_COLUMNS = ['Paciente', 'Status', 'Atualizado', 'Idade', 'Sexo', 'Ações'];

    return (
        <div className="overflow-hidden rounded-2xl border border-border/80">
            <table className="w-full">
                <thead className={`border-b border-border/70 ${listTableStyles.header}`}>
                    <tr>
                        {DASHBOARD_COLUMNS.map((column) => {
                            return (
                                <th key={column} className={listTableStyles.head}>
                                    {column}
                                </th>
                            );
                        })}
                    </tr>
                </thead>

                <motion.tbody variants={containerVariants} initial="hidden" animate="visible">
                    {reports.map((report) => (
                        <ReportListItem
                            key={report.id}
                            report={report}
                            onDelete={() => onDelete(report.id)}
                            onExport={() => onExport(report.id)}
                            viewMode="list"
                        />
                    ))}
                </motion.tbody>
            </table>
        </div>
    );
}

export default DashboardAsTable;
